import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Motion";
import { ReviewForm } from "@/components/ReviewForm";
import { TESTIMONIALS, INSTAGRAM, HANDLE } from "@/data/site";

const Stars = () => <p className="text-gold tracking-[0.3em] text-sm" aria-label="5 stars">★★★★★</p>;

const Card = ({ t, i }) => (
  <Reveal delay={(i % 3) * 0.06} className="break-inside-avoid mb-6">
    <figure data-testid={`review-card-${i}`} className="bg-linen p-8 md:p-10">
      <Stars />
      <blockquote className="font-display text-2xl md:text-[1.7rem] leading-[1.3] mt-6 text-espresso">“{t.q}”</blockquote>
      <figcaption className="mt-8 flex items-center gap-4">
        <span className="w-8 h-px bg-gold" />
        <span className="text-sm uppercase tracking-[0.24em]">{t.who}</span>
        <span className="font-display italic text-mocha">{t.occasion}</span>
      </figcaption>
    </figure>
  </Reveal>
);

export default function Reviews() {
  const [first, ...rest] = TESTIMONIALS;
  return (
    <main data-testid="reviews-page">
      <PageHero eyebrow="Reviews" lines={["Kind words,", <span className="italic text-mocha">sweetly said.</span>]}
        intro={`${TESTIMONIALS.length} five-star reviews from clients of Lise’s Sugar Studio.`} />
      <section className="mx-auto max-w-[1440px] px-5 md:px-10 pb-16">
        <Reveal className="border-y border-espresso/15 py-16 md:py-24 grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-3"><Stars /><p data-testid="reviews-rating" className="font-display text-6xl mt-4">5.0</p><p className="eyebrow mt-2">Average rating</p></div>
          <figure className="lg:col-span-9">
            <blockquote className="font-display font-light text-3xl sm:text-4xl lg:text-5xl leading-[1.15]">“{first.q}”</blockquote>
            <figcaption className="mt-8 text-sm uppercase tracking-[0.24em]">{first.who} <span className="normal-case tracking-normal font-display italic text-mocha text-base ml-3">{first.occasion}</span></figcaption>
          </figure>
        </Reveal>
      </section>
      <section className="mx-auto max-w-[1440px] px-5 md:px-10 pb-28">
        <div className="columns-1 md:columns-2 gap-6">
          {rest.map((t, i) => <Card key={t.who} t={t} i={i} />)}
        </div>
        <section id="leave-a-review" className="mt-24 grid lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-4">
            <p className="eyebrow mb-6">Leave a Review</p>
            <h2 className="font-display font-light text-5xl md:text-6xl leading-[0.95]">Enjoyed your <span className="italic text-mocha">order?</span></h2>
            <p className="text-mocha mt-6 leading-relaxed max-w-sm">Share a few words about your desserts. Reviews are sent to Lise and may be featured on the site.</p>
          </Reveal>
          <Reveal className="lg:col-span-7 lg:col-start-6 bg-linen p-6 sm:p-10 md:p-14">
            <ReviewForm />
          </Reveal>
        </section>
        <div className="mt-20 flex flex-col md:flex-row md:items-center justify-between gap-8 border-t border-espresso/15 pt-12">
          <p className="font-display text-4xl md:text-5xl font-light">Your turn to taste.</p>
          <div className="flex flex-wrap gap-3">
            <Link to="/shop" data-testid="reviews-shop-cta" className="btn btn-dark">Shop Desserts</Link>
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="reviews-instagram" className="btn btn-line"><Instagram className="w-4 h-4" strokeWidth={1.4} />{HANDLE}</a>
          </div>
        </div>
      </section>
    </main>
  );
}
